export const DEFAULT_ACTIVATION_DELAY = 5000;
export const DEFAULT_ACTIVATION_DELAY = 5000;
